var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"height":"100%","background-color":"#ffffff"},attrs:{"id":"pdfIframe"}},[_c('iframe',{attrs:{"id":"iframe","src":_vm.newPdfUrl,"width":"100%","height":"100%","frameborder":"1"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440bd1b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lookPdf.vue
// module id = null
// module chunks = 